module.exports = function($stateProvider) {
  $stateProvider.state('shipping', {
    parent: 'root',
    abstract: true,
    onEnter: ['editShippingModal', editShippingModal => editShippingModal.open()],
    params: {
      shipment: {}
    }
  });
};

module.exports.$inject = ['$stateProvider'];
